import React from 'react';
import { withTranslation } from 'react-i18next';
import AnchorLink from 'react-anchor-link-smooth-scroll';

// styles
import './ycFooter.scss';

import { ClickLink } from '../../tools/Utils';
import imgGithub from '../../assets/images/c-footer/git.svg';
import imgLinkedin from '../../assets/images/c-footer/linkedin.svg';
import imgFacebook from '../../assets/images/c-footer/facebook.svg';
import imgGoTop from '../../assets/images/c-footer/go-top.svg';

export const YcFooter = withTranslation()(
  class YcFooterClass extends React.PureComponent {
    clickLink = ClickLink;
    socials = [
      {
        name: 'github',
        img: imgGithub,
        link: 'https://github.com/ysocorp',
      },
      {
        name: 'linkedin',
        img: imgLinkedin,
        link: 'https://www.linkedin.com/company/yso-corp',
      },
      {
        name: 'facebook',
        img: imgFacebook,
        link: 'https://www.facebook.com/profile.php?id=100009275581843',
      },
    ];

    render() {
      return (
        <footer className="yc-footer">
          <div className="row">
            <div className="col-lg-2 info-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2623.514120196835!2d2.370756115903679!3d48.886538406678156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66dd770c64c15%3A0x965179db7a764e72!2s40%20Av.%20de%20Flandre%2C%2075019%20Paris!5e0!3m2!1sen!2sfr!4v1644487442559!5m2!1sen!2sfr"
                class="map" frameborder="0" allowfullscreen="" aria-hidden="false" tabindex="0" loading="lazy" title="YSO Corp address">
              </iframe>
            </div>
            <div className="col-lg-3 info-text">
              <b>YSO Corp</b> <br />
              <br /> 40 avenue de flandre <br /> 75019, Paris <br />
              <br />
              <b>
                Tel : +33 1 39 64 17 35 <br /> Email : contact@ysocorp.com
              </b>
            </div>
            <div className="col-lg-4 social-link">
              <p>Retrouvez-nous sur</p>
              <br />
              {this.socials.map((social, index) => (
                <div className="link d-inline" key={index}>
                  <a href={social.link} target="_blank" rel="noopener noreferrer">
                    <img className="img-map" src={social.img} alt="Map" />
                  </a>
                </div>
              ))}
            </div>
            <div className="col-lg-3 copyright">
              <AnchorLink offset="0px" href="#go-top">
                <img className="img-top " src={imgGoTop} alt="GoTop" />
              </AnchorLink>
              <br />
              <div className="copy-text">Copyright ©2013-2022 YSO Corp | Tous droits réservés</div>
            </div>
          </div>
        </footer>
      );
    }
  },
);
